document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'venat-wishlist';
  const LOCALIZATION = window.VENAT_LOCALIZATION || {};
  const I18N = LOCALIZATION.strings || {};
  const ROOT = LOCALIZATION.root || '/';
  const LOCALE = LOCALIZATION.locale || document.documentElement.lang || 'sv';
  const CURRENCY = LOCALIZATION.currency || 'SEK';
  const INTL_LOCALES = { sv: 'sv-SE', en: 'en-GB', da: 'da-DK', nb: 'nb-NO', fi: 'fi-FI', de: 'de-DE', nl: 'nl-NL' };
  const container = document.querySelector('[data-venat-wishlist]');

  if (!container) return;

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(wishlist)
    );
  }

  function formatPrice(price) {
    return new Intl.NumberFormat(INTL_LOCALES[LOCALE] || LOCALE, {
      style: 'currency',
      currency: CURRENCY
    }).format(price / 100);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function getProducts() {
    try {
      const response = await fetch(
        `${ROOT}products.json?limit=250`
      );

      if (!response.ok) {
        return [];
      }

      const data = await response.json();

      return Array.isArray(data.products)
        ? data.products
        : [];
    } catch (error) {
      return [];
    }
  }

  function createCard(product) {
    const card = document.createElement('div');

    card.className = 'venat-wishlist-card';
    card.dataset.wishlistProduct = product.id;

    const image =
      product.images && product.images.length
        ? product.images[0].src
        : '';

    const variant =
      product.variants && product.variants[0];

    if (!variant) {
      return card;
    }

    const available = variant.available;
    const safeTitle = escapeHtml(product.title);
    const safeHandle = encodeURIComponent(product.handle);
    const safeImage = escapeHtml(image);

    card.innerHTML = `
      <div class="venat-wishlist-card-image">

        <button
          type="button"
          class="venat-wishlist-remove"
          data-remove-product="${product.id}"
          aria-label="${I18N.removeWishlist || 'Remove from wishlist'}"
        >
          ♥
        </button>

        <a href="${ROOT}products/${safeHandle}">
          ${
            image
              ? `
                <img
                  src="${safeImage}"
                  alt="${safeTitle}"
                  loading="lazy"
                >
              `
              : ''
          }
        </a>

      </div>

      <div class="venat-wishlist-card-info">

        <a
          href="${ROOT}products/${safeHandle}"
          class="venat-wishlist-card-title"
        >
          ${safeTitle}
        </a>

        <div class="venat-wishlist-card-price">
          ${formatPrice(variant.price * 100)}
        </div>

        <button
          type="button"
          class="venat-wishlist-add-to-bag"
          data-variant-id="${variant.id}"
          aria-label="${
            available
              ? (I18N.addToCart || 'Add to cart') + ': ' + safeTitle
              : safeTitle + ' — ' + (I18N.soldOut || 'Sold out')
          }"
          ${available ? '' : 'disabled'}
        >

          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M5.5 8.5h13l1.1 10.5H4.4L5.5 8.5Z"
              stroke="currentColor"
              stroke-width="1.45"
              stroke-linejoin="round"
            />

            <path
              d="M9 9V6.5a3 3 0 0 1 6 0V9"
              stroke="currentColor"
              stroke-width="1.45"
              stroke-linecap="round"
            />
          </svg>

          <span class="visually-hidden">
            ${available ? (I18N.addToCart || 'Add to cart') : (I18N.soldOut || 'Sold out')}
          </span>

        </button>

      </div>
    `;

    const addButton = card.querySelector(
      '.venat-wishlist-add-to-bag'
    );

    if (addButton && available) {
      addButton.addEventListener(
        'click',
        function () {
          if (addButton.disabled) {
            return;
          }

          addButton.disabled = true;
          addButton.classList.add('is-loading');

          fetch((window.routes && window.routes.cart_add_url) || `${ROOT}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: variant.id,
              quantity: 1
            })
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error(
                  I18N.cartError || 'The product could not be added to the cart.'
                );
              }

              return response.json();
            })
            .then(function () {
              addButton.classList.remove('is-loading');
              addButton.classList.add('is-added');

              addButton.setAttribute(
                'aria-label',
                (I18N.addedToCart || 'Added to cart') + ': ' + safeTitle
              );

              const hiddenText =
                addButton.querySelector(
                  '.visually-hidden'
                );

              if (hiddenText) {
                hiddenText.textContent =
                  I18N.addedToCart || 'Added to cart';
              }

              window.dispatchEvent(
                new CustomEvent(
                  'venat:cart-updated'
                )
              );

              window.setTimeout(function () {
                addButton.disabled = false;
                addButton.classList.remove('is-added');

                addButton.setAttribute(
                  'aria-label',
                  (I18N.addToCart || 'Add to cart') + ': ' + safeTitle
                );

                if (hiddenText) {
                  hiddenText.textContent =
                    I18N.addToCart || 'Add to cart';
                }
              }, 1800);
            })
            .catch(function (error) {
              console.error(
                'VÉNAT Wishlist:',
                error
              );

              addButton.disabled = false;
              addButton.classList.remove('is-loading');
            });
        }
      );
    }

    return card;
  }

  function showEmpty() {
    container.innerHTML = `
      <div class="venat-wishlist-empty">

        <div class="venat-wishlist-empty-heart">
          ♡
        </div>

        <h2>
          ${I18N.emptyTitle || 'Your wishlist is empty'}
        </h2>

        <p>
          ${I18N.emptyText || 'Save your VÉNAT favourites by selecting the heart.'}
        </p>

        <a
          href="${ROOT}collections/all"
          class="venat-wishlist-shop"
        >
          ${I18N.explore || 'Explore products'}
        </a>

      </div>
    `;
  }

  async function renderWishlist() {
    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      showEmpty();
      return;
    }

    container.innerHTML = `
      <div class="venat-wishlist-loading">
        ${I18N.loading || 'Loading your favourites...'}
      </div>
    `;

    const catalog = await getProducts();

    const validProducts = wishlist
      .map(function (productId) {
        return catalog.find(function (product) {
          return (
            String(product.id) ===
            String(productId)
          );
        });
      })
      .filter(Boolean);

    if (validProducts.length === 0) {
      showEmpty();
      return;
    }

    container.innerHTML = '';

    const grid = document.createElement('div');
    grid.className = 'venat-wishlist-grid';

    validProducts.forEach(function (product) {
      grid.appendChild(
        createCard(product)
      );
    });

    container.appendChild(grid);

    container
      .querySelectorAll(
        '[data-remove-product]'
      )
      .forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            const productId =
              button.getAttribute(
                'data-remove-product'
              );

            let updatedWishlist =
              getWishlist();

            updatedWishlist =
              updatedWishlist.filter(
                function (savedId) {
                  return (
                    String(savedId) !==
                    String(productId)
                  );
                }
              );

            saveWishlist(updatedWishlist);

            window.dispatchEvent(
              new CustomEvent(
                'venat:wishlist:updated'
              )
            );
          }
        );
      });
  }

  renderWishlist();

  window.addEventListener(
    'venat:wishlist:updated',
    function () {
      renderWishlist();
    }
  );
});